import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@ispm-client/modules/core/services/http-client';
import {BP_MODEL_URL} from '@ispm/shared/bpmn/services/config';
import {BpmnDeploymentIdentifier} from '@ispm-shared/modules/bpmn';

@Injectable()
export class BpmnDeploymentService {

  constructor(private httpServer: HttpClient) {
  }

  saveBpmnXML(name: string, xml: string, final: boolean, knowledgeBase: string,type?: string): Observable<BpmnDeploymentIdentifier> {
    return type ? this.httpServer.post(BP_MODEL_URL, {
      name: name,
      data: xml,
      final,
      bpmnType: type,
      kb: knowledgeBase
    }) : this.httpServer.post(BP_MODEL_URL, {
      name: name,
      data: xml,
      final,
      kb: knowledgeBase
    });
  }
}
